import { QueryClient } from '@tanstack/react-query';

/**
 * Do not use me anywhere *except*
 *
 * - In the root index.js file for <QueryClientProvider />
 * - In `./invalidate` module, abstracting invalidation helpers
 * - The integration platform WorkerManager
 *
 * When if you need access to `queryClient`, you can use `useQueryClient()` in a
 * react component.
 *
 * The single query client that we use to maintain results throughout the application
 * Read about me here: https://kizen.atlassian.net/wiki/spaces/KZN/pages/2000420865/React+Query+API+Data+Fetching
 */
export const unsafeRootQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 1 minute:  How long mark this item as being fresh it is considered stale.
      staleTime: 60000,
      // 10 minutes: Stays in memory for this length of time.
      gcTime: 600000,
      refetchOnMount: true,
      refetchOnReconnect: true,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        if (error.isAxiosError) {
          const status = error.response?.status ?? error.code;

          if (status === 403 || status === 404) {
            return false;
          }
        }
        return failureCount < 2; // total of 3 attempts
      },
      retryOnMount: true, // Failed results will be retried if they are requested again
      throwOnError: true, // Queries should fail to the EB when it rejects.
    },
    mutations: {
      retry: false, // Never retry failed mutations

      // Mutations should not arrive at EB since it would
      // clear local state that would likely lose user data
      throwOnError: false,
    },
  },
});
